import {
    createMuiTheme
} from "@material-ui/core/styles";
import tableStyle from './components/tableStyle';
import cardStyle from './components/cardStyle';

export default createMuiTheme({
    overrides: {
        MuiPaper: {
            root: {
                ...cardStyle.card
            },
            elevation4: {
                ...cardStyle.card
            }
        },
        MuiPopover: {
            paper: {
                display: 'inline-block',
                width: 'auto'
            }
        },
        MUIDataTable: {
            root: { textTransform: "none" },
            caption: {
                textTransform: "none"
            }
        },
        MUIDataTableBody: {
            root: {
                ...tableStyle.table, ...tableStyle.tableResponsive
            },
            emptyTitle: {
                textTransform: "none"
            }
        },
        MUIDataTableBodyCell: {
            root: {
                ...tableStyle.tableCell
            }
        },
        MUIDataTableBodyRow: {
            root: {
                //...tableStyle.tableStripedRow,
                ...tableStyle.tableRowHover,
                cursor: "pointer"
            }
        },
        MUIDataTableHeadCell: {
            root: {
                ...tableStyle.tableHeadCell
            }
        },
        MUIDataTableToolbar: {
            titleText: {
                textTransform: "none"
            }
        }
        //Modal
    },
    typography: {
        useNextVariants: true,
    }
});